import React from "react";
import "./buttons.scss";
import { Icon } from "@ui-kit";

/**
 * Button component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Button content (label, icons, etc.)
 * @param {string|React.Component} [props.iconLeft] - left icon source/component
 * @param {string|React.Component} [props.iconRight] - right icon source/component
 * @param {string} [props.alt='button icon'] - alt text for icons
 * @param {string} [props.className] - additional CSS classes
 * @param {boolean} [props.isDisabled=false] - disables the button
 * @param {'primary'|'primary-warning'|'primary-danger'|'secondary'|'secondary-danger'|'secondary-gray'|'secondary-gray-danger'|'tertiary-danger'|'tertiary-gray'|'link-color'|'link-gray'|'link-danger'|'horizontal-gray'} [props.theme='primary'] - visual theme
 * @param {'sm'|'md'|'lg'|'xl'} [props.size='xl'] - size modifier
 * @param {Object} [props.styles] - inline styles (not currently applied)
 * @param {...Object} [options] - other native button attributes (onClick, type, etc.)
 * @returns {JSX.Element}
 */
const Button = (props) => {
  const {
    children,
    iconLeft,
    iconRight,
    alt = "button icon",
    className = "",
    isDisabled = false,
    theme = "primary",
    size = "xl",
    styles: propsStyles,
    ...options
  } = props;
  const rootClasses = ["button", theme, size, className];

  if (isDisabled) {
    rootClasses.push("disabled");
  }

  return (
    <button {...options} className={rootClasses.join(" ")}>
      {iconLeft && (
        <div className="button__container-icon d-flex mr-15 button__container-icon-left">
          <Icon
            src={iconLeft}
            className="button__img button__img-left"
            alt={alt}
          ></Icon>
        </div>
      )}
      {children}
      {iconRight && (
        <div className="button__container-icon d-flex ml-15 button__container-icon-right">
          <Icon src={iconRight} className="button__img-right" alt={alt}></Icon>
        </div>
      )}
    </button>
  );
};

export default Button;

/* <Button variant="accent" onPress={() => alert('Hey there!')}>
  <Icon styles={{ paddingRight: '15px' }} src={Temp} alt="React Logo" />
  <Text as="span">Icon + Label</Text>
  <Icon styles={{ paddingLeft: '15px' }} src={Temp} alt="React Logo" />
</Button>; */
